<template>
  <div class="item" :class="props.data.is_read_modal_window ? '' : 'item--new'">
    <AvatarImage class="item__avatar" :src="props.data.notification_from_user.avatar" :size="32" />
    <p class="item__hdr">
      <a class="item__name" :href="props.data.notification_from_user.profile_url">
        {{ props.data.notification_from_user.name }}
      </a>
      <span class="item__add-txt" v-if="!props.isSystemMessage">
        {{ notificationType }} {{ formatTimeAgo(props.data.created) }}
      </span>
    </p>
    <p class="item__comment" v-html="props.data.comment"></p>
    <div class="item__ftr">
      <ArrowBorder class="item__arrow" />
      <div class="item__answer-box">
        <button class="item__link" v-if="props.isSystemMessage" @click="onBindTelegram">Привязать Телеграм в Настройках</button>
        <p class="item__answer-text" v-else>{{ props.data.user_comment }}</p>
        <a class="item__link" @click="goToComment($event)" :href="getUrl(props.data)">{{ props.data.title }}</a>
      </div>
    </div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  import { computed } from 'vue';
  import { formatTime_dn_mn_y_h_min, useTimeAgo } from '@/Groups/Notifications/private/imports/externalUtils.js';
  import { useNotificationPopupUrl } from '@/Groups/Notifications/private/imports/callContentPopup';
  //-----------------------
  import ArrowBorder from '../../svg/ArrowBorder.vue';
  import { AvatarImage } from '../../imports/externalTemplates';
  //-----------------------
  const { toOpenContentPopup, getUrl } = useNotificationPopupUrl();
  //-----------------------
  const { formatTimeAgo } = useTimeAgo();
  //-----------------------
  const props = defineProps(Props());
  const emit = defineEmits(['bind-telegram']);
  //-----------------------
  //Переместить пользователя к комментарию
  const goToComment = (e) => {
    e.preventDefault();
    toOpenContentPopup(props.data);
  }
  //Определить тип уведомления
  const notificationType = computed(() => {
	  if (props.data.notification_type === 'notification') return 'ответил';
	  if (props.data.notification_type === 'mention') return 'упомянул вас';
	  return '';
	});
  //Эмит к родителю
  const onBindTelegram = () => {
    emit('bind-telegram', props.data);
  };
</script>

<style lang="scss" scoped>
  @import "./styles";
</style>